/* GearFrost FAQ — live search filter. Filters the <details> Q&A by text (question + answer) and hides
 * any category heading that has no visible question under it. No network, no dependencies. */
(function () {
  if (!customElements.get('gf-faq')) {
    customElements.define(
      'gf-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-faq-search]');
          this.list = this.querySelector('[data-faq-list]');
          this.empty = this.querySelector('[data-faq-empty]');
          if (!this.input || !this.list) return;
          this.items = Array.prototype.slice.call(this.list.querySelectorAll('[data-faq-item]'));
          this.cats = Array.prototype.slice.call(this.list.querySelectorAll('[data-faq-cat]'));
          this._onInput = this.filter.bind(this);
          this.input.addEventListener('input', this._onInput);
        }

        disconnectedCallback() {
          if (this.input) this.input.removeEventListener('input', this._onInput);
        }

        filter() {
          var q = (this.input.value || '').trim().toLowerCase();
          var visibleCount = 0;
          this.items.forEach(function (item) {
            var match = !q || (item.textContent || '').toLowerCase().indexOf(q) !== -1;
            item.hidden = !match;
            if (match) visibleCount += 1;
          });
          // Hide a category heading when no question between it and the next heading is visible.
          this.cats.forEach(function (cat) {
            var visible = false;
            var el = cat.nextElementSibling;
            while (el && !el.hasAttribute('data-faq-cat')) {
              if (el.hasAttribute('data-faq-item') && !el.hidden) {
                visible = true;
                break;
              }
              el = el.nextElementSibling;
            }
            cat.hidden = !visible;
          });
          if (this.empty) this.empty.hidden = visibleCount !== 0;
        }
      }
    );
  }
})();
